<template>
  <div class="l-edit-dialog-box" style="max-height: 75vh; height: 75vh">
    <!--信息展示-->
    <h3 style="margin-top: 0">基础信息</h3>
    <table class="l-info-table" style="margin-top: -10px" v-loading="loading">
      <tbody>
        <tr>
          <td>
            <span class="l-info-label">耗材编号：</span>
            <span class="l-info-content">{{ form_data.consumable_no }}</span>
          </td>
          <td>
            <span class="l-info-label">耗材名称：</span>
            <span class="l-info-content">{{ form_data.name }}</span>
          </td>
          <td>
            <span class="l-info-label">品牌：</span>
            <span class="l-info-content">{{ form_data.brand }}</span>
          </td>
        </tr>
        <tr>
          <td>
            <span class="l-info-label">规格型号：</span>
            <span class="l-info-content">{{ form_data.recv_user_name }}</span>
          </td>
          <td>
            <span class="l-info-label">库存：</span>
            <span class="l-info-content">{{ form_data.consumable_count }}</span>
          </td>
          <td>
            <span class="l-info-label">创建人：</span>
            <span class="l-info-content">{{ form_data.create_user_name }}</span>
          </td>
        </tr>

        <tr>
          <td>
            <span class="l-info-label">创建时间：</span>
            <span class="l-info-content">
              {{ form_data.create_time }}
            </span>
          </td>
        </tr>

        <tr>
          <td colspan="3">
            <span class="l-info-label">备注：</span>
            <span class="l-info-content">{{ form_data.remark }}</span>
          </td>
        </tr>

      </tbody>
    </table>

    <l-divider></l-divider>

    <div>
      <h3 style="margin-top: 0">耗材照片</h3>
      <div v-if="form_data.preview_imgs.length > 0">
        <my-img-component :images="form_data.preview_imgs"></my-img-component>
      </div>
      <div v-else class="l-sec-font-color">暂无耗材照片</div>
    </div>

    <template v-if="show_select_assets">
      <!--关联的资产-->
      <l-divider></l-divider>
      <h3>关联资产</h3>
      <div>
        <l-assets-common-table :data="selected_assets" readonly row-key="id" v-if="selected_assets.length>0"></l-assets-common-table>
        <div v-else class="l-sec-font-color">暂无关联资产</div>
      </div>

      <div class="l-dialog-footer">
        <!--查看信息时可见-->
        <el-button @click="cancel">关 闭</el-button>
      </div>

    </template>

    <l-divider></l-divider>

    <div>
      <h3 style="margin-top: 0">操作记录</h3>
      <l-table ref="table" row-key="id" :data="log_list" height="400px">
        <el-table-column prop="index" label="序号" min-width="60"></el-table-column>
        <el-table-column prop="type" label="处理类型" min-width="100" show-overflow-tooltip>
          <template v-slot="{ row }">
            <l-consumable-log-type :state="row.type"></l-consumable-log-type>
          </template>
        </el-table-column>
        <el-table-column prop="order_no" label="关联单号" min-width="150" show-overflow-tooltip></el-table-column>
        <el-table-column prop="content" label="处理内容" min-width="230" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="create_user_name" label="操作人" min-width="80" show-overflow-tooltip></el-table-column>
        <el-table-column prop="create_time" label="操作时间" min-width="180" show-overflow-tooltip></el-table-column>
      </l-table>
    </div>

    <div class="l-dialog-footer">
      <!--查看信息时可见-->
      <el-button @click="cancel">关 闭</el-button>
    </div>
  </div>

</template>

<script>
import AssetsTable from "../assets/CommonTable";
import MyImg from "@/components/img/MyImg";
import Types from "./Types.vue";
export default {
  name: "l-consumable-info",
  components: {
    [AssetsTable.name]: AssetsTable,
    [MyImg.name]: MyImg,
    [Types.name]: Types,
  },
  props: {
    id: {
      type: [Number, String],
      default: null,
    },
    visible: {
      type: Boolean,
    },
  },
  computed: {
    hasId() {
      return this.$props.id !== null;
    },
  },
  data() {
    return {
      loading: false,

      show_select_assets: false,

      review_remark_visible: false, //是否弹出审核窗
      review_state: "",

      //表单数据
      submitting: false,

      del_selected_ids: [],

      selected_assets: [],

      log_list: [],

      form_data: {
        preview_imgs: [],
      },
    };
  },

  watch: {
    visible: {
      immediate: true,
      handler(val) {
        if (val) {
          this.getData();
        }
      },
    },
  },

  methods: {
    //点击取消通知父组件关闭对话框
    cancel() {
      this.$emit("update:visible", false);
    },
    //获取添加数据
    getData() {
      //编辑获取数据
      this.loading = true;
      let params = { id: this.$props.id };
      if (this.$props.orderNo) {
        params = { order_no: this.$props.orderNo };
      }
      this.$_invoke("consumable_getInfo", params)
        .then((ret) => {
          this.$nextTick(() => {
            this.form_data = ret.data;
          });
          this.selected_assets = ret.selected_assets;
          this.show_select_assets = ret.show_select_assets;
          this.log_list = ret.log_list;
        })
        .finally(() => {
          this.loading = false;
        });
    },

    //弹出审核描述
    showReviewRemark(state) {
      this.review_state = state;
      this.$nextTick(() => {
        this.review_remark_visible = true;
      });
    },

    //审核提交成功
    onReviewSucess() {
      this.review_remark_visible = false;
      this.$emit("on-success");
    },
  },
};
</script>
